import {
  parisDateTimeToUtcIso,
  toParisDateInputValue,
  toParisTimeInputValue,
} from "./parisDateTime";
export type PersonalReminder = {
  id: string;
  user_id: string;
  case_id: string;
  case_title: string;
  action: "phone" | "email";
  due_at: string;
  status: "pending" | "done" | "cancelled";
};
export function reminderDateToUtc(date: string, time: string, now = Date.now()) {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(date) || !/^([01]\d|2[0-3]):[0-5]\d$/.test(time))
    throw new Error("Choisissez une date et une heure valides.");
  const iso = parisDateTimeToUtcIso(date, time);
  if (toParisDateInputValue(iso) !== date || toParisTimeInputValue(iso) !== time)
    throw new Error("Cette heure n’existe pas à Paris à cette date. Choisissez une autre heure.");
  if (Date.parse(iso) <= now) throw new Error("Le rappel doit être prévu dans le futur.");
  return iso;
}
export const duePersonalReminders = (rows: PersonalReminder[], userId: string, now = Date.now()) =>
  rows
    .filter((r) => r.user_id === userId && r.status === "pending" && Date.parse(r.due_at) <= now)
    .sort((a, b) => a.due_at.localeCompare(b.due_at));
